import { CatSkeleton } from 'components/blocks-components';
import cx from 'classnames';

export const EquipmentDescriptionLoader = ({
  isDesktop
}: {
  isDesktop: boolean;
}) => {
  return (
    <div
      className={cx('d-md-flex d-none flex-column', {
        'row-gap-2 w-75': isDesktop,
        'row-gap-1 w-100': !isDesktop
      })}
    >
      <CatSkeleton className="w-25" size="sm" />
      <CatSkeleton className="w-100" size="sm" />
      <CatSkeleton className="w-100 d-lg-block d-md-none" size="sm" />
    </div>
  );
};
